import { Product } from './Product'
import { Field, ObjectType, ID, Float, InputType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { RelatedEntity } from '../base/RelatedEntity'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ProductBillOfMaterialInput')
export class ProductBillOfMaterial {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('pbom') })
  _id: string

  @Field(() => Product)
  @Prop({ type: RelatedEntity })
  product: any //we set this as "any" becauase of circular dependency, this bill of materials is also needed on the product itself

  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  @Field(() => String)
  @Prop({ type: String })
  remarks?: string

  @Field(() => [String])
  @Prop({ type: [String] })
  tags?: string[]

  @Field(() => Float)
  @Prop({ type: Number })
  cost: number

  @Field(() => Boolean)
  @Prop({ type: Boolean })
  requiredToBuild: boolean

  //No need to store this value, no need for resolver also, we just need it for the data schema of Bill Of Material
  //This is the physical or shared count when building the product
  @Field(() => Float)
  sharedInventory: number

  //No need to store this value, no need for resolver also, we just need it for the data schema of Bill Of Material
  //This is the physical or shared count when building the product
  @Field(() => Float)
  runningInventory: number
}

@ObjectType()
@InputType('ProductBillOfMaterialsWithParentProductInput')
export class ProductBillOfMaterialsWithParentProduct extends ProductBillOfMaterial {
  @Field(() => String)
  parentProductId: string
}
